import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { Link } from "react-router-dom";
const TopGameVendor = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 9,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  };


  const logos = [
    {
      logo: "/cards/4.jpg",
      link: "/spribe",
    },
    {
      logo: "/cards/e3.webp",
      link: "/evolution",
    },
    {
      logo: "/cards/ae4.jpg",
      link: "/ae-sexy",
    },
    {
      logo: "/cards/v9.webp",
      link: "/vivo",
    },
    {
      logo: "/cards/4.jpg",
      link: "/spribe",
    },
    {
      logo: "/cards/e3.webp",
      link: "/evolution",
    },
    {
      logo: "/cards/ae4.jpg",
      link: "/ae-sexy",
    },
    {
      logo: "/cards/v9.webp",
      link: "/vivo",
    },

  ];
  return (
    <>
   

      <div className="overflow-hidden hide-scrollbar">
        <Slider {...settings}>
          {logos.map((logo, index) => (
            <Link to={logo.link} key={logo.link}>
              <div className="p-1">
                <img
                  src={logo.logo}
                  alt={`Vendor Logo ${index + 1}`}
                  className="w-[100%] h-[80px] sm:h-[140px] outline-none rounded"
                  loading="lazy"
                />
              </div>
            </Link>
          ))}
        </Slider>
      </div>
    </>
  );
};

export default TopGameVendor;
